class z {
  constructor() {
    this._m = /* @__PURE__ */ new Map();
  }
  on(s, a) {
    return this._m.has(s) || this._m.set(s, /* @__PURE__ */ new Set()), this._m.get(s).add(a), () => this.off(s, a);
  }
  off(s, a) {
    const e = this._m.get(s);
    e && e.delete(a);
  }
  emit(s, a) {
    const e = this._m.get(s);
    e && e.forEach((m) => {
      try {
        m(a);
      } catch {
      }
    });
  }
}
const E = "https://18.139.114.52";
function M() {
  const o = new z();
  let s = null, a = null, e = null, m = new MediaStream(), S = null, v = !1;
  const c = (t) => o.emit("log", t), T = async (t, n = {}, u = 8e3) => {
    const r = new AbortController(), l = setTimeout(() => r.abort(), u);
    try {
      return await fetch(t, { ...n, signal: r.signal });
    } finally {
      clearTimeout(l);
    }
  };
  async function $() {
    await navigator.mediaDevices.getUserMedia({ video: !0, audio: !0 }).catch(() => {
    });
    const t = await navigator.mediaDevices.enumerateDevices();
    return {
      cameras: t.filter((n) => n.kind === "videoinput"),
      mics: t.filter((n) => n.kind === "audioinput")
    };
  }
  function C(t) {
    t && t.getTracks().forEach((n) => {
      try {
        n.stop();
      } catch {
      }
    });
  }
  async function P({ videoDeviceId: t, audioDeviceId: n } = {}) {
    x();
    const u = {
      video: t ? { deviceId: { exact: t } } : !0,
      audio: n ? { deviceId: { exact: n } } : !0
    };
    return s = await navigator.mediaDevices.getUserMedia(u), o.emit("preview-stream", s), c("本地预览已开启"), s;
  }
  function x() {
    C(s), s = null, o.emit("preview-stopped");
  }
  async function _({
    app: t,
    stream: n,
    preferredTcp: u = "0"
  }) {
    var g, y;
    const r = E;
    if (!t || !n || !r) throw new Error("缺少推流参数 app/stream/zlm");
    if (!s && (await P(), !s))
      throw new Error("无法获取本地媒体流");
    if (a)
      try {
        a.close();
      } catch {
      }
    S = { app: t, stream: n, zlm: r, preferredTcp: u, playZlm: r }, a = new RTCPeerConnection({ iceServers: [] }), s.getTracks().forEach((h) => a.addTrack(h, s)), a.oniceconnectionstatechange = () => {
      c("推流 ICE 状态: " + a.iceConnectionState), o.emit("push-ice", a.iceConnectionState);
    };
    const l = await a.createOffer({ offerToReceiveAudio: !1, offerToReceiveVideo: !1 });
    await a.setLocalDescription(l), c("推流 offer 创建完毕，SDP 长度: " + (((g = l == null ? void 0 : l.sdp) == null ? void 0 : g.length) || 0));
    const w = `${r}/index/api/webrtc?app=${encodeURIComponent(t)}&stream=${encodeURIComponent(n)}&type=push&preferred_tcp=${u}`;
    c("推流信令: " + w);
    const f = await fetch(w, {
      method: "POST",
      headers: { "Content-Type": "text/plain;charset=utf-8" },
      body: l.sdp
    });
    if (!f.ok) {
      const h = await f.text().catch(() => "");
      throw new Error(`信令请求失败: ${f.status} ${f.statusText} ${h ? "- " + h.slice(0, 160) : ""}`);
    }
    const i = await f.json().catch(async () => {
      const h = await f.text().catch(() => "");
      throw new Error("解析信令响应失败: " + (h || "非 JSON 响应"));
    });
    if (i.code !== 0 || !i.sdp) throw new Error(i.msg || "推流失败：无有效 SDP");
    const p = { type: "answer", sdp: i.sdp };
    return c("推流 answer 收到，SDP 长度: " + (((y = i.sdp) == null ? void 0 : y.length) || 0)), await a.setRemoteDescription(p), c("推流成功"), o.emit("push-success", { app: t, stream: n, zlm: r, preferredTcp: u, playZlm: S.playZlm }), { app: t, stream: n, zlm: r, preferredTcp: u };
  }
  function k() {
    if (a) {
      try {
        a.close();
      } catch {
      }
      a = null;
    }
    c("推流已停止"), o.emit("push-stopped");
  }
  async function D({
    app: t,
    stream: n,
    zlm: u,
    preferredTcp: r = "0"
  }) {
    var y, h;
    const l = u || E;
    if (!t || !n || !l) throw new Error("缺少拉流参数 app/stream/zlm");
    if (v) {
      c("拉流启动中，跳过本次触发");
      return;
    }
    if (v = !0, e) {
      try {
        e.close();
      } catch {
      }
      e = null;
    }
    e = new RTCPeerConnection({ iceServers: [], sdpSemantics: "unified-plan" }), m = new MediaStream();
    try {
      e.addTransceiver("video", { direction: "recvonly" });
    } catch (d) {
      c("添加 video transceiver 失败: " + d.message);
    }
    try {
      e.addTransceiver("audio", { direction: "recvonly" });
    } catch (d) {
      c("添加 audio transceiver 失败: " + d.message);
    }
    e.ontrack = (d) => {
      d.streams[0].getTracks().forEach((b) => m.addTrack(b)), o.emit("play-stream", m), c("收到远端 track: " + d.track.kind);
    }, e.oniceconnectionstatechange = () => {
      c("拉流 ICE 状态: " + e.iceConnectionState), o.emit("play-ice", e.iceConnectionState);
    };
    const w = await e.createOffer();
    await e.setLocalDescription(w), c("拉流 offer 创建完毕，SDP 长度: " + (((y = w == null ? void 0 : w.sdp) == null ? void 0 : y.length) || 0));
    const f = `${l}/index/api/webrtc?app=${encodeURIComponent(t)}&stream=${encodeURIComponent(n)}&type=play&preferred_tcp=${r}`;
    c("拉流信令: " + f);
    const i = await T(
      f,
      {
        method: "POST",
        headers: { "Content-Type": "text/plain;charset=utf-8" },
        body: w.sdp
      },
      8e3
    );
    if (c(`拉流响应: ${i.status} ${i.statusText || ""}`.trim()), !i.ok) {
      const d = await i.text().catch(() => "");
      throw new Error(`信令请求失败: ${i.status} ${i.statusText} ${d ? "- " + d.slice(0, 160) : ""}`);
    }
    const p = await i.json().catch(async () => {
      const d = await i.text().catch(() => "");
      throw new Error("解析信令响应失败: " + (d || "非 JSON 响应"));
    });
    if (p.code !== 0 || !p.sdp) throw new Error(p.msg || "拉流失败：无有效 SDP");
    const g = { type: "answer", sdp: p.sdp };
    return c("拉流 answer 收到，SDP 长度: " + (((h = p.sdp) == null ? void 0 : h.length) || 0)), await e.setRemoteDescription(g), c("拉流已建立"), o.emit("play-success", { app: t, stream: n, zlm: l, preferredTcp: r }), v = !1, { app: t, stream: n, zlm: l, preferredTcp: r };
  }
  function R() {
    if (e) {
      try {
        e.close();
      } catch {
      }
      e = null;
    }
    m && (C(m), m = new MediaStream(), o.emit("play-stream", m)), c("拉流已停止"), o.emit("play-stopped");
  }
  return {
    on: (...t) => o.on(...t),
    off: (...t) => o.off(...t),
    getDevices: $,
    startPreview: P,
    stopPreview: x,
    startPush: _,
    stopPush: k,
    startPlay: D,
    stopPlay: R
  };
}
export {
  M as CreateSellyRtcEngine
};
//# sourceMappingURL=sellycloudwebsdk.es.js.map
